import { render, staticRenderFns } from "./ATSSidebar.vue?vue&type=template&id=5dcb8fe9&scoped=true"
import script from "./ATSSidebar.vue?vue&type=script&lang=js"
export * from "./ATSSidebar.vue?vue&type=script&lang=js"
import style0 from "./ATSSidebar.vue?vue&type=style&index=0&id=5dcb8fe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcb8fe9",
  null
  
)

export default component.exports